<script>
import routable from 'vuetify/lib/mixins/routable'

import colorable from '~/mixins/colorable.js'

export default {
  name: 'ElevatedSurface',
  mixins: [
    colorable,
    routable
  ],
  props: {
    elevation: {
      type: [Number, String],
      default: 1
    },
    flat: {
      type: Boolean,
      default: false
    },
    sharp: {
      type: Boolean,
      default: false
    },
    tag: {
      type: String,
      default: 'div'
    }
  },
  computed: {
    classes: vm => [
      'surface',
      'surface--elevation-' + ((vm.flat && '0') || vm.elevation),
      vm.to && 'surface--route',
      vm.sharp && 'surface--sharp',
      vm.isThemeColor && vm.color
    ].filter(Boolean),
    context: vm => ({
      contrasting: vm.contrasting,
      isDark: vm.isDark
    })
  },
  render (h) {
    const { tag, data } = this.generateRouteLink(this.classes)
    const content = this.$slots.default || this.$scopedSlots.default(this.context)
    data.attrs.tag = tag === 'router-link' ? 'a' : this.tag

    if (!this.isThemeColor) {
      data.style = { 'background-color': this.color }
    }

    return h(tag, data, content)
  }
}
</script>

<style lang="scss">
  a.surface {
    color: inherit;
    display: block;
    text-decoration: none;
  }
  .surface {
    --surface-shadow: rgba(0, 0, 0, 0.08);
    background: #FFF;
    border-radius: 4px;
    overflow: hidden;
    position: relative;

    &--elevation-0 {
      border: 1px solid var(--surface-shadow);
    }
    &--elevation-1 {
      box-shadow: 0 1px 3px 0 var(--surface-shadow);
    }
    &--elevation-2 {
      --surface-shadow: rgba(0, 0, 0, 0.10);
      box-shadow: 0 2px 4px 0 var(--surface-shadow);
    }
    &--elevation-3 {
      --surface-shadow: rgba(0, 0, 0, 0.16);
      box-shadow: 0 3px 10px 0 var(--surface-shadow);
    }

    &--sharp {
      border-radius: 0;
    }

    &--route {
      cursor: pointer;
    }
  }
</style>
